module.exports = __webpack_public_path__ + "static/img/share.639966f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/9/share.jpg
// module id = 15sT
// module chunks = 27